<ng-template #displayTemplateRef
             let-cellData
             let-rowData="rowData">
  <div class="flex flex-column">
    @if (rowData.corresponding) {
      <p-tag value="Corresponding author"
             i18n-value
             severity="danger"
             class="et-tag-secondary">
      </p-tag>
    }
    <span>{{ getCellValue(cellData) }}</span>
  </div>
</ng-template>